import React from "react";
import Badge from "../../../../../styles/customComponents/Badge";
import { useSelector } from "react-redux";

const LotsDetails = ({ singleLot, marginTop = "70px" }) => {
  const isDisplayed = useSelector(
    (state) => state.displayHonorairesReducer.isDisplayed
  );
  const filteredPdfs =
    singleLot.documents_pdfs.filter((doc) => doc.type === "plan_vente") || [];

  return (
    <section id="lotsDetails" style={{ marginTop: marginTop }}>
      <p className="semibold fs16 pink mb-10">Lots</p>
      <div className="d-flex gap50 bg-white radius5 px-20 py-20 ">
        <div className="w50 d-flex justify-content-center align-items-center ">
          <div className="pdf-container w100">
            {filteredPdfs[0]?.document ? (
              <iframe
                src={`${process.env.REACT_APP_IMAGE_END_POINT}${filteredPdfs[0]?.document[0]?.url}`}
                className="w100 radius5"
                style={{ height: "500px", border: "none" }}
              />
            ) : singleLot?.images[0]?.image[0]?.url ? (
              <img
                src={`${process.env.REACT_APP_IMAGE_END_POINT}${singleLot.images[0]?.image[0]?.url}`}
                title="PDF Viewer"
                className="w100 radius5"
                style={{ height: "auto", border: "none" }}
              />
            ) : (
              <img
                src="./assets/imgNotFound.webp"
                title="Not Found"
                className="w100 radius5"
                style={{ height: "auto", border: "none" }}
              />
            )}
          </div>
        </div>
        <div className="w100">
          <div className="d-flex gap20 mb-20">
            <div className="d-flex flex-column gap20 w70 ">
              <div className="d-flex gap70 ">
                <div className="radius5 position-relative  text-center">
                  <img src="./assets/progress.png" alt="appart" />
                  <span className="progression fs21 semibold text-dark-grey">
                    {isDisplayed
                      ? singleLot.commission
                        ? singleLot?.commission?.match(/\d+(?:\.\d+)?/) + "%"
                        : "NC"
                      : "***"}
                  </span>
                  <p className="fs17 regular text-dark-grey">Honoraires</p>
                </div>
                <div className="d-flex flex-column justify-content-center">
                  <span className="fs16 regular text-dark-grey">
                    Dont immobilier
                  </span>
                  <span className="fs21 semibold text-dark-grey">
                    {Intl.NumberFormat("fr-FR").format(singleLot.price_total)}€
                  </span>
                  <span className="fs11 regular text-dark-grey">
                    TVA {singleLot.price_vat_rate} %
                  </span>
                </div>
              </div>
              <div className="d-flex gap10 flex-wrap">
                {singleLot.project_types?.map((badge) => (
                  <span
                    key={badge.documentId}
                    className="fs11 bg-green radius5 py-1 px-2 text-white"
                    title={badge.label}
                  >
                    {badge.label}
                  </span>
                ))}
              </div>
            </div>
            <div className="vertical-line"></div>
            <div className="grid-template ">
              <div className="text-center">
                <p className="blueGreen semibold fs14">Prix/m2</p>
                <span className="blueGreen semibold fs16">
                  {(singleLot.price_incl_tax / singleLot.surface).toFixed(0)} €
                </span>
              </div>
              <div className="text-center">
                <p className="blueGreen semibold fs14">Loyer/mois</p>
                <span className="blueGreen semibold fs16">
                  {singleLot.rent}€
                </span>
              </div>
              <div className="text-center">
                <p className="blueGreen semibold fs14">Plafond Pinel</p>
                <span className="blueGreen semibold fs16">NC</span>
              </div>
              <div className="text-center">
                <p className="blueGreen semibold fs14">Rentabilité</p>
                <span className="blueGreen semibold fs16">
                  {singleLot.rent_profitability}
                </span>
              </div>
            </div>
          </div>
          <div className="separator mb-43"></div>
          <div className="d-flex justify-content-between w100 gap70">
            <div className="flex-1">
              <p className="progDescriptionTitle mb-43">Général</p>
              <div className="d-flex flex-column gap12">
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Lots</span>
                  <span className="darkGrey semibold fs14">
                    {singleLot.reference}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Nature</span>
                  <span className="darkGrey semibold fs14 text-capitalize">
                    {singleLot.type}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Type</span>
                  <span className="darkGrey semibold fs14 text-capitalize">
                    {singleLot.typology}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Étage</span>
                  <span className="darkGrey semibold fs14">
                    {" "}
                    {singleLot.floor == null
                      ? "NC"
                      : singleLot.floor == 0
                      ? "RDC"
                      : singleLot.floor == 1
                      ? "1er"
                      : singleLot.floor + "ème"}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="darkGrey medium fs12">Exposition</span>
                  <span className="darkGrey semibold fs14">
                    {singleLot?.geo_orientations.length > 0
                      ? singleLot?.geo_orientations
                          .map((orientation) => orientation.orientation)
                          .join(", ")
                      : "N/C"}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex-1">
              <p className="progDescriptionTitle mb-43">Surfaces</p>
              <div className="d-flex flex-column gap12">
                <div className="d-flex justify-content-between gap56">
                  <span className="darkGrey medium fs12">
                    Surface habitable
                  </span>
                  <span className="darkGrey semibold fs14">
                    {singleLot.surface} m2
                  </span>
                </div>
                <div className="d-flex justify-content-between gap56">
                  <span className="darkGrey medium fs12">Surface pondérée</span>
                  <span className="darkGrey semibold fs14">
                    {singleLot.weighted_surface} m2
                  </span>
                </div>
                <div className="d-flex justify-content-between gap56">
                  <span className="darkGrey medium fs12">
                    Surface extérieure
                  </span>
                  <span className="darkGrey semibold fs14">
                    {(singleLot.weighted_surface - singleLot.surface).toFixed(
                      2
                    )}{" "}
                    m2
                  </span>
                </div>
              </div>
            </div>
            <div className="flex-1">
              <p className="progDescriptionTitle mb-43">Annexes</p>
              <div>
                <div>
                  <span className="darkGrey medium fs12">NC</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LotsDetails;
